<div>
    <app-image [img]="imageSource" [css]="prevImgCss" [type]="type" (click)="inputField.click()"></app-image>
    <input 
        [disabled]="disabledControl"
        #inputField 
        type="file" 
        hidden 
        accept="image/png, image/jpeg"
        (change)="fileSelected($event)" 
        (click)="inputField.value = ''"
    />
</div>

